import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const GoldenHourSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$goldenHourSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$goldenHourSection',
  });

  return (
    <section id="hp-goldenHour" className="hp-section goldenHour-section goldenHour">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('bed')} className="clearfix reverse">
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homepage/goldenHourSection/lem-au-soleil-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homepage/goldenHourSection/lem-au-soleil-mob.jpg"
              />
              <img
                data-src="/images/homepage/goldenHourSection/lem-au-soleil.jpg"
                alt={t('alt')}
                src="/images/homepage/goldenHourSection/lem-au-soleil.jpg"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="960"
                height="700"
              />
            </picture>
          </div>
          <div className="stack">
            <div className="flight-bar" />
            <h2>{t('title')}</h2>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-main">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default GoldenHourSection;
